// extracted by mini-css-extract-plugin
export var component = "SubscriptionEvent-module--component--zL0Dw";
export var title = "SubscriptionEvent-module--title--ZiewJ";
export var type = "SubscriptionEvent-module--type--A+Yi1";